module.exports = __webpack_public_path__ + "img/service.6836361a.png";